import AsyncStorage from "@react-native-async-storage/async-storage";
import dayjs from "dayjs";
import jwtDecode from "jwt-decode";

const prefix = "cache";
const expiryInMinutes = 5;
const key = "authToken";

// setItem() is used both to add new data item (when no data for given key exists), and to modify existing item (when previous data for given key exists).
const store = async (key, value) => {
    try {
        const item = {
            value,
            timestamp: Date.now(),
        };
        await AsyncStorage.setItem(prefix + key, JSON.stringify(item));
    } catch (error) {
        console.log(error);
    }
};

const isExpired = (item) => {
    const now = dayjs();
    const storedTime = dayjs(item.timestamp);
    return now.diff(storedTime, "minute") > expiryInMinutes;
};

// getItem - returns a promise that either resolves to stored value when data is found for given key, or returns null otherwise
// removeitem - Removes item for a key, invokes (optional) callback once completed.
const get = async (key) => {
    try {
        const value = await AsyncStorage.getItem(prefix + key);
        const item = JSON.parse(value);

        if (!item) return null;

        if (isExpired(item)) {
            // Command Query Separation (CQS)
            await AsyncStorage.removeItem(prefix + key);
            return null;
        }

        return item.value;
    } catch (error) {
        console.log(error);
    }
};

const storeToken = async (authToken) => {
    try {
        await AsyncStorage.setItem(key, authToken);
    } catch (error) {
        console.log("Error storing the auth token", error);
    }
};

const getToken = async () => {
    try {
        return await AsyncStorage.getItem(key);
    } catch (error) {
        console.log("Error getting the auth token", error);
    }
};
const getUser = async () => {
    const token = await getToken();
    return token ? jwtDecode(token) : null;
};

const removeToken = async () => {
    try {
        await AsyncStorage.removeItem(key);
    } catch (error) {
        console.log("Error removing the auth token", error);
    }
};

export default {
    store,
    get,
    getToken,
    getUser,
    removeToken,
    storeToken,
};
